import { pickAssistantMessageMetaFromResult, postChatCompletion } from '@/services/chatApi'
import { applyApiBlocksOnlyResult } from './applyApiBlocksOnlyResult.js'
import { reportApiCompletionFailure } from './reportApiCompletionFailure.js'
import { streamApiCompletionText } from './streamApiCompletionText.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   apiMessages: Array<{ role: string, content: string }>,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession.js').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} ApiCompletionCtx
 */

/** @param {ApiCompletionCtx} ctx */
export function runApiCompletionStream(ctx) {
  const { apiMessages, signal, session, onSettled } = ctx

  void postChatCompletion({ messages: apiMessages, signal }).then((result) => {
    if (result.ok === false && result.code === 'ABORTED') {
      session.dispose()
      return
    }

    if (!result.ok) {
      reportApiCompletionFailure(ctx, result.message)
      return
    }

    const fullText = result.text ?? ''
    const blocksFromApi = Array.isArray(result.blocks) && result.blocks.length ? result.blocks : null
    const assistantMeta = pickAssistantMessageMetaFromResult(result)

    if (fullText) ctx.onChatEvent?.({ type: 'chunk', text: fullText })
    ctx.onChatEvent?.({ type: 'done' })

    if (!fullText.length && blocksFromApi) {
      applyApiBlocksOnlyResult(ctx, blocksFromApi, assistantMeta)
      return
    }

    streamApiCompletionText({ ...ctx, fullText, blocksFromApi, assistantMeta })
  }).finally(() => onSettled?.())
}
